module.exports = __webpack_public_path__ + "static/media/cow.fc581cb5.svg";